import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom"; // Import Link
import axios from "../../axios";
import "dropify/dist/css/dropify.min.css";
import "dropify/dist/js/dropify.min.js";
import $ from "jquery";
import { useNavigate } from "react-router-dom";

const AddBanner = () => {
  const { id } = useParams();
  const isEditing = !!id;
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef();
  const navigate = useNavigate();

  // Fetch banner details for edit mode
  useEffect(() => {
    if (isEditing) {
      axios
        .get(`/banners/${id}`)
        .then((res) => {
          setTitle(
            res.data.title === "null" || res.data.title == null
              ? ""
              : res.data.title
          );
          setImagePreview(res.data.image_url);
        })
        .catch((err) => {
          console.error("Error loading banner:", err);
          alert("Failed to load banner details");
        });
    }
  }, [id, isEditing]);

  // Dropify reinit for edit mode
  useEffect(() => {
    if (isEditing && imagePreview) {
      const $input = $(fileInputRef.current);
      const drEvent = $input.data("dropify");
      if (drEvent) drEvent.destroy();

      $input.attr("data-default-file", imagePreview);

      setTimeout(() => {
        $input.dropify();
      }, 50);
    }
  }, [imagePreview, isEditing]);

  // Dropify init for add mode
  useEffect(() => {
    if (!isEditing) {
      const $input = $(fileInputRef.current);
      const drEvent = $input.data("dropify");
      if (drEvent) drEvent.destroy();

      $input.removeAttr("data-default-file");

      setTimeout(() => {
        $input.dropify();
      }, 50);
    }
  }, [isEditing]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };
  const handleBack = () => {
    navigate("/admin/bannerList");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const sanitizedTitle =
      title === "null" || title.trim() === "" ? null : title;

    const formData = new FormData();
    formData.append("title", sanitizedTitle);

    if (image) formData.append("image", image);

    const request = isEditing
      ? axios.post(`/banners/${id}?_method=PUT`, formData)
      : axios.post("/banners", formData);

    request
      .then(() => {
        alert(
          isEditing
            ? "Banner updated successfully!"
            : "Banner added successfully!"
        );
        // Use navigate for SPA navigation without refresh
        navigate("/admin/bannerList");
      })
      .catch((err) => {
        console.error("Error saving banner:", err.response?.data);
        alert("Failed to save banner");
      });
  };

  return (
    <div className="main-content">
      {/* Replace <a> with <Link> */}
      <button
        className="btn text-black mb-3 border-0 text-decoration-none"
        onClick={handleBack}>
        <h5>
          ←{" "}
          <span className="ms-2">
            {isEditing ? "Edit Banner" : "Add Banner"}
          </span>
        </h5>
      </button>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="form-label">Title </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter banner title"
            value={title ?? ""}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className="mb-4">
          <label className="form-label">Banner Image</label>
          <input
            type="file"
            ref={fileInputRef}
            className="form-control dropify"
            onChange={handleImageChange}
            accept="image/*"
          />
        </div>

        <div className="text-end">
          <button
            type="submit"
            className="btn gold-add-btn py-2 px-4 w-auto rounded-0 text-white">
            {isEditing ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddBanner;
